import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const reloadPriceSettingsData = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.RELOAD_PRICE_SETTINGS_DATA),
        switchMap(() => {
            let reloadRequests = [];

            if (state$.value.pricing.genericPriceGroups.length > 0) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_DATA,
                    tabId: 0
                });
            }

            if (
                state$.value.pricing.genericColorantPurchase !== null ||
                state$.value.pricing.genericColorantSell !== null ||
                state$.value.pricing.genericColorantVat !== null
            ) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_COLORANT_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_COLORANT_DATA,
                    tabId: 0
                });
            }

            if (
                state$.value.pricing.genericProductPurchase !== null ||
                state$.value.pricing.genericProductSell !== null ||
                state$.value.pricing.genericProductVat !== null
            ) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_PRODUCT_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_PRODUCT_DATA,
                    tabId: 0
                });
            }

            if (state$.value.pricing.genericPackageSurcharge !== null) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_GENERIC_PACKAGE_DATA
                    },
                    method: handlers.PRICING_GET_GENERIC_PACKAGE_DATA,
                    tabId: 0
                });
            }

            if (state$.value.pricing.colorantData.length > 0) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_COLORANTS_DATA
                    },
                    method: handlers.PRICING_GET_COLORANTS_DATA,
                    tabId: 0
                });
            }

            if (state$.value.pricing.baseInProductsData.length > 0 && state$.value.pricing.activeProduct !== null) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_DATA,
                        params: {
                            productId: state$.value.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_DATA,
                    tabId: 0
                });
            }

            if (
                state$.value.pricing.baseInProductPackagesData.length > 0 &&
                state$.value.pricing.activeProduct !== null
            ) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                        params: {
                            productId: state$.value.pricing.activeProduct.id
                        }
                    },
                    method: handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA,
                    tabId: 0
                });
            }

            if (state$.value.pricing.packageData.length > 0) {
                reloadRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_PRICING_GET_PACKAGES_DATA
                    },
                    method: handlers.PRICING_GET_PACKAGES_DATA,
                    tabId: 0
                });
            }

            return reloadRequests;
        })
    );

export default [reloadPriceSettingsData];
